import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
import { CheckCircle2Icon, TrendingUpIcon, ZapIcon } from 'lucide-react';
export function TrustScoreSection() {
  const points = ['Behavioral Analytics', 'Transaction Pattern Analysis', 'Explainable AI Decisions', 'Regulatory Compliant'];
  return <section className="py-24 bg-slate border-y border-white/5 overflow-hidden" data-id="element-676" data-mp="2grgx8v4l0dch">
      <div className="max-w-7xl mx-auto px-6" data-id="element-677" data-mp="34hkqq9o22wpr">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-678" data-mp="34ivvabpbs8hx">
          {/* Content */}
          <div data-id="element-679" data-mp="2uqq3b1z2pr2q">
            <FadeIn data-id="element-680" data-mp="2ur87qlvw3blq">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue/10 border border-blue/20 text-blue text-sm font-medium mb-6" data-id="element-681" data-mp="2uporuwe5b2kh">
                Proprietary Technology
              </div>
              <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-682" data-mp="3nelyg28zvaxe">
                The FIQIS Trust Score
              </h2>
              <p className="text-xl text-gray-400 mb-8" data-id="element-683" data-mp="3s7x7ma1a43sh">
                A proprietary, explainable scoring model that drives smarter
                lending decisions within your institutional boundaries. Move
                beyond traditional credit scores.
              </p>
            </FadeIn>

            <StaggerContainer className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10" data-id="element-684" data-mp="1yohngn2fxw04">
              {points.map((point, i) => <StaggerItem key={i} className="flex items-center gap-3" data-id="element-685" data-mp="28kb4ojr3udo8" data-mpi={i}>
                  <CheckCircle2Icon className="w-5 h-5 text-teal flex-shrink-0" data-id="element-686" data-mp="23lq76s38m83h" />
                  <span className="text-gray-300 font-medium" data-id="element-687" data-mp="23nu6sxu3skxy">{point}</span>
                </StaggerItem>)}
            </StaggerContainer>

            <FadeIn delay={0.4} className="flex flex-col sm:flex-row gap-6 p-6 bg-navy rounded-xl border border-white/5" data-id="element-688" data-mp="2djnpkyyf1ao6">
              <div className="flex-1" data-id="element-689" data-mp="j5wc1ocyu6ng">
                <div className="flex items-center gap-2 text-teal mb-2" data-id="element-690" data-mp="j6xxmmrlybjf">
                  <TrendingUpIcon className="w-5 h-5" data-id="element-691" data-mp="2ib64jejv6y02" />
                  <span className="font-bold text-2xl" data-id="element-692" data-mp="2ich6r9xnvxp2">Up to 40%</span>
                </div>
                <p className="text-sm text-gray-400" data-id="element-693" data-mp="2n9zjlbesux2c">
                  Increase in micro-lending approval rates
                </p>
              </div>
              <div className="w-px bg-white/10 hidden sm:block" data-id="element-694" data-mp="2x8gdoh91brsm"></div>
              <div className="flex-1" data-id="element-695" data-mp="2x5kgiv50h758">
                <div className="flex items-center gap-2 text-blue mb-2" data-id="element-696" data-mp="31aa9oc8ac7mg">
                  <ZapIcon className="w-5 h-5" data-id="element-697" data-mp="368btx0hg6czi" />
                  <span className="font-bold text-2xl" data-id="element-698" data-mp="3670qj1rwz78x">3x Faster</span>
                </div>
                <p className="text-sm text-gray-400" data-id="element-699" data-mp="3b0mtu3c6tys2">
                  Credit decisioning process
                </p>
              </div>
            </FadeIn>
          </div>

          {/* Visual Gauge */}
          <FadeIn direction="left" delay={0.2} className="relative flex justify-center items-center" data-id="element-700" data-mp="3kyswwo9qdayi">
            <div className="relative w-full max-w-md aspect-square flex items-center justify-center" data-id="element-701" data-mp="1dbhnlrehkqd4">
              {/* Decorative background circles */}
              <div className="absolute inset-0 rounded-full border border-white/5 scale-110" data-id="element-702" data-mp="198l1vrtnge4y"></div>
              <div className="absolute inset-0 rounded-full border border-white/5 scale-90" data-id="element-703" data-mp="14bl381z4qdnv"></div>

              {/* SVG Gauge */}
              <svg viewBox="0 0 200 200" className="w-full h-full transform -rotate-90 drop-shadow-[0_0_15px_rgba(0,212,170,0.3)]" data-id="element-704" data-mp="zeb4fvpuopnd">
                {/* Background track */}
                <circle cx="100" cy="100" r="80" fill="none" stroke="#111D35" strokeWidth="12" strokeLinecap="round" data-id="element-705" data-mp="1n9dwsdnv5b8l" />
                {/* Progress track */}
                <circle cx="100" cy="100" r="80" fill="none" stroke="url(#tealGradient)" strokeWidth="12" strokeLinecap="round" strokeDasharray="502" strokeDashoffset="120" className="animate-[pulse-slow_3s_ease-in-out_infinite]" data-id="element-706" data-mp="2ayzv6ywevmfj" />
                <defs data-id="element-707" data-mp="1qj6rw8lsi0ee">
                  <linearGradient id="tealGradient" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-708" data-mp="1qink3kpusse3">
                    <stop offset="0%" stopColor="#3B82F6" data-id="element-709" data-mp="2j95kuf33uhoc" />
                    <stop offset="100%" stopColor="#00D4AA" data-id="element-710" data-mp="24h569e041wtw" />
                  </linearGradient>
                </defs>
              </svg>

              {/* Center Content */}
              <div className="absolute flex flex-col items-center justify-center text-center" data-id="element-711" data-mp="2x6c22586k8bg">
                <span className="text-gray-400 text-sm font-medium uppercase tracking-widest mb-1" data-id="element-712" data-mp="31xan1i445ul1">
                  Trust Score
                </span>
                <span className="text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-white to-gray-400" data-id="element-713" data-mp="qgqvgsp188vv">
                  842
                </span>
                <span className="text-teal text-sm font-semibold mt-2 bg-teal/10 px-3 py-1 rounded-full" data-id="element-714" data-mp="z9u3umktlvjn">
                  Excellent
                </span>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}